export enum ButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Success = 'Success',
  Error = 'Error',
  Warning = 'Warning',
  Information = 'Information',
}

export type ButtonType = 'Round' | 'Square';
export type ButtonSize = 'XSmall' | 'Small' | 'Medium' | 'Large' | 'XLarge';
export type ButtonState =
  | 'Enabled'
  | 'Hovered'
  | 'Focused'
  | 'Pressed'
  | 'Disabled';

import type React from 'react';

export interface ButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  /**
   * HTML button type: button, submit, or reset
   */
  type?: 'button' | 'submit' | 'reset';
  /**
   * The text label displayed on the button
   */
  label?: string;
  /**
   * Whether to show an icon
   */
  showIcon?: boolean;
  /**
   * Icon component to display (React element)
   */
  icon?: React.ReactNode;
  /**
   * Button variant: Primary, Secondary, Success, Error, Warning, or Information
   */
  variant?: ButtonVariant;
  /**
   * Button type variant: Round or Square
   */
  buttonType?: ButtonType;
  /**
   * Button size variant
   */
  size?: ButtonSize;
  /**
   * Button state variant
   */
  state?: ButtonState;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Custom background color (overrides variant default)
   */
  customBgColor?: string;
  /**
   * Custom background color on hover
   */
  customBgColorHover?: string;
  /**
   * Custom border color
   */
  customBorderColor?: string;
  /**
   * Custom text color
   */
  customTextColor?: string;
  /**
   * Custom font weight
   */
  customFontWeight?: number;
}
